import RandingStyle26 from "../../randing/RandingStyle26";

function Randing490({ urlCode, urlCodeSettingId }) {
  const handleCallClick = () => {
    if (urlCodeSettingId) {
      fetch(
        `https://funnelsolution.co.kr/api/urlcode/request-count/${encodeURIComponent(urlCodeSettingId)}`,
        { method: "POST", headers: { "Content-Type": "application/json" } }
      ).catch((err) => console.error("request count 증가 실패:", err));
    }
  };

  const callButtonStyle = `
    .randing490-call-button {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .randing490-call-button img {
      width: 70px;
      height: 70px;
    }
    @media (max-width: 768px) {
      .randing490-call-button img {
        width: 32px;
        height: 32px;
      }
    }
  `;

  const customTopContent = (
    <div style={{
      maxWidth: "768px",
      margin: "0 auto",
      backgroundColor: "#f5efed"
    }}>
      <style>{callButtonStyle}</style>
      <div style={{ position: "relative", width: "100%" }}>
        <img
          src={`${process.env.REACT_APP_CDN_BASE}/images/490/7.jpg`}
          alt="치아교정 고민중이세요?"
          style={{ width: "100%", display: "block" }}
        />
        <a
          href="tel:032-567-8528"
          className="randing490-call-button"
          onClick={handleCallClick}
        >
          <img
            src={`${process.env.REACT_APP_CDN_BASE}/images/490/call_icon.png`}
            alt="전화하기"
          />
        </a>
      </div>
    </div>
  );

  const footerData = {
    line1: "검단뉴욕치과의원 | 대표 : 추성욱 | 사업자등록번호 : 619-28-01281",
    line2: "인천 서구 원당대로 1045, 4층 404호,405호,406호,407호(원당동,금호헤리티지7) TEL. 032-567-8528",
    line3: "COPYRIGHT© GEOMDAN NEWYORK CLINIC ALL RIGHTS RESERVED"
  };

  const altTexts = {
    step1: "검단 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 0% 치아교정을 정말 하고 싶다?",
    step2: "검단 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 30% 교정이 필요한 이유? 돌출입 덧니 부정교합 기타",
    step3: "검단 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 60% 1. 교정 치과 선택 시 고려대상은? 비용 위치 의사 경력 병원 크기",
    step4: "검단 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 100% 1. 성함과 연락처를 입력해주세요 이름 연락처"
  };

  const optionLabels = {
    step1: {
      left: "O",
      right: "X"
    },
    step2: {
      left1: "돌출입",
      right1: "덧니",
      left2: "부정교합",
      right2: "기타"
    },
    step3: {
      left1: "비용",
      right1: "위치",
      left2: "의사경력",
      right2: "병원크기"
    }
  };

  return (
    <>
      {customTopContent}
      <RandingStyle26
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/490`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/490/postBtn.png`}
        companyName="검단뉴욕치과의원"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        customFooter={true}
        footerData={footerData}
        altTexts={altTexts}
        optionLabels={optionLabels}
        autoNextOnSelect={true}
        footerStyle={{ paddingTop: "100px", background: "#F5F0EC" }}
      />
    </>
  );
}

export default Randing490;
